var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 8,
    viewBox: "0 0 92 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.845665 4.35355C0.650406 4.15829 0.650406 3.8417 0.845665 3.64644L4.02765 0.464462C4.22291 0.2692 4.53949 0.2692 4.73476 0.464462C4.93002 0.659725 4.93002 0.976307 4.73476 1.17157L1.90633 4L4.73476 6.82842C4.93002 7.02369 4.93002 7.34027 4.73476 7.53553C4.53949 7.73079 4.22291 7.73079 4.02765 7.53553L0.845665 4.35355ZM91.1992 4.5L1.19922 4.5L1.19922 3.5L91.1992 3.5L91.1992 4.5Z",
    fill: "#144B46"
  })));
}

export default SvgArrow;